export default __webpack_public_path__ + "static/media/13.581af93f.webp";